const home =
{
    title       : 'Bienvenue sur votre Plateforme d\'Épidémiosurveillance.' ,
    description : 'Administrez vos données sanitaires dans cet espace sécurisé.'
};

export default home  ;
